import { checkSearchObject } from "app/common/LocalFunction";
import { Department } from "app/common/Model/Department";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  deleteDepartmentById,
  getDepartmentById,
  pagingDepartment,
  saveDepartment,
  syncDrug,
} from "app/services/DepartmentService";
import { downloadTemplateDepartment, importDepartmentExcel } from "app/services/ImportExcelService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class DepartmentStore {
  searchDepartment = new SearchObject();
  pageDepartment = null;
  selectedDepartment = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteDepartment = false;
  listAllDepartments = [];
  recentlyUpdated = false;
  defaultWorkingDepartment = null;

  constructor() {
    makeAutoObservable(this);
  }

  getAllDepartment = async () => {
    if (!this.listAllDepartments?.length || this.recentlyUpdated) {
      const searchObjectForAll = {
        pageIndex: 1,
        pageSize: 1000000,
      };
      return await pagingDepartment(searchObjectForAll)
        .then(({ data }) => {
          this.listAllDepartments = data?.content;
          this.recentlyUpdated = false;
          return this.listAllDepartments;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
          return [];
        });
    }
    return this.listAllDepartments;
  };

  pagingDepartment = async () => {
    return await pagingDepartment(this.searchDepartment)
      .then(({ data }) => {
        this.pageDepartment = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchDepartment) => {
    this.searchDepartment = checkSearchObject(
      this.searchDepartment,
      searchDepartment
    );
    this.pagingDepartment();
  };

  handleOpenFormCreateOrEdit = (departmentId) => {
    if (Boolean(departmentId)) {
      getDepartmentById(departmentId)
        .then(({ data }) => {
          this.selectedDepartment = data;
          this.openFormCreateOrEdit = true;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    } else {
      this.selectedDepartment = new Department();
      this.openFormCreateOrEdit = true;
    }
  };

  saveDepartment = async (department, { setSubmitting }) => {
    if (department?.parent != null) {
      department.parentId = department?.parent?.id;
    }

    return await saveDepartment(department)
      .then(() => {
        this.selectedDepartment = null;
        toast.success("Lưu thông tin cơ sở (chi nhánh) thành công!");
        this.handleClosePopup();
        this.pagingDepartment();
        this.recentlyUpdated = true;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin cơ sở (chi nhánh) có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleDeleteDepartment = (department) => {
    this.selectedDepartment = { id: department?.id };
    this.openConfirmDeleteDepartment = true;
  };

  handleConfirmDeleteDepartment = async () => {
    return await deleteDepartmentById(this?.selectedDepartment?.id)
      .then(() => {
        if (
          this.searchDepartment.pageIndex > 1 &&
          this.pageDepartment.content.length === 1
        ) {
          this.searchDepartment.pageIndex -= 1;
        }
        toast.success("Xóa cơ sở (chi nhánh) thành công!");
        this.handleClosePopup();
        this.recentlyUpdated = true;
        this.pagingDepartment();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa cơ sở (chi nhánh) có lỗi");
      });
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteDepartment = false;
  };

  setDefaultWorkingDepartment = staffDepartment => {
    this.defaultWorkingDepartment = staffDepartment;
  }



  // //for choosing healthcare subDepartment popup in ChooseSubDepartmentPopup.jsx
  listSubDepartment = [];
  subDepartmentIdSet = null;

  isValidChild = (subDepartment) => {
    if (subDepartment && subDepartment?.id) return true;
    console.error("Invalid manipulated element");
    return false;
  };

  addChild = (subDepartment) => {
    if (!this.isValidChild(subDepartment)) return;
    this.listSubDepartment.push(subDepartment);
    this.subDepartmentIdSet.add(subDepartment?.id);
  };

  initializeListSubDepartment = (subDepartments) => {
    this.subDepartmentIdSet = new Set();
    this.listSubDepartment = [];
    if (subDepartments && subDepartments?.length > 0) {
      for (let i = 0; i < subDepartments.length; i++) {
        this.addChild(subDepartments[i]);
      }
    }
  };

  removeChild = (subDepartment) => {
    if (!this.isValidChild(subDepartment)) return;
    if (this.subDepartmentIdSet?.has(subDepartment?.id)) {
      this.subDepartmentIdSet.delete(subDepartment?.id);
    } else {
      console.error("Element is not exist");
    }
  };

  isExist = (subDepartment) => {
    if (!this.isValidChild(subDepartment)) return;
    return this.subDepartmentIdSet?.has(subDepartment?.id);
  };

  getSubDepartmentIdSet = () => {
    return this.subDepartmentIdSet;
  };

  getListSubDepartment = () => {
    const bufferIdSet = new Set();
    const data = [];
    if (this.listSubDepartment && this.listSubDepartment?.length > 0) {
      for (let i = 0; i < this.listSubDepartment.length; i++) {
        const subDepartment = this.listSubDepartment[i];
        if (
          this.isExist(subDepartment) &&
          !bufferIdSet.has(subDepartment?.id)
        ) {
          data.push(subDepartment);
          bufferIdSet.add(subDepartment?.id);
        }
      }
    }
    this.listSubDepartment = data;
    return data;
  };
  //end

  //for choosing department popup in ChooseDepartmentPopup.jsx
  listDepartment = [];
  departmentIdSet = null;

  isValidDepartment = (department) => {
    if (department && department?.id) return true;
    console.error("Invalid manipulated element");
    return false;
  };

  addDepartment = (department) => {
    if (!this.isValidDepartment(department)) return;
    this.listDepartment.push(department);
    this.departmentIdSet.add(department?.id);
  };

  initializeListDepartment = (departments) => {
    this.departmentIdSet = new Set();
    this.listDepartment = [];
    this.defaultWorkingDepartment = null
    if (departments && departments?.length > 0) {
      for (let i = 0; i < departments.length; i++) {
        this.addDepartment(departments[i]);
        if(departments[i].isDefault)
        this.defaultWorkingDepartment = departments[i]
      }
    }
  };

  removeDepartment = (department) => {
    if (!this.isValidDepartment(department)) return;
    if (this.departmentIdSet.has(department?.id)) {
      this.departmentIdSet.delete(department?.id);
    } else {
      console.error("Element is not exist");
    }
  };

  isExistDepartment = (department) => {
    if (!this.isValidDepartment(department)) return;
    return this.departmentIdSet.has(department?.id);
  };

  getListDepartment = () => {
    const bufferIdSet = new Set();
    const data = [];
    if (this.listDepartment && this.listDepartment?.length > 0) {
      for (let i = 0; i < this.listDepartment.length; i++) {
        const department = this.listDepartment[i];
        if (
          this.isExistDepartment(department) &&
          !bufferIdSet.has(department?.id)
        ) {
          data.push(department);
          bufferIdSet.add(department?.id);
        }
      }
    }
    this.listDepartment = data;
    return data;
  };

  SubmitExcelDepartment = (file) => {
    importDepartmentExcel(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchDepartment = {
                ...this.searchDepartment,
                pageIndex:1
            }
            this.pagingDepartment()
        }).catch((error) => {
            toast.error("Nhập excel thất bại")
        })
    }

  handleDownloadExcelTemplate = async () => {
    try {
      const response = await downloadTemplateDepartment();

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "CO_SO_CHI_NHANH.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  }

  hanleSyncDrug = () => {
    syncDrug()
      .then(({ data }) => {
        toast.success("Đồng bộ thành công");
        this.pagingDepartment();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đồng bộ dữ liệu có lỗi");
      });
  };

  resetStore = () => {
    this.searchDepartment = new SearchObject();
    this.pageDepartment = null;
    this.selectedDepartment = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteDepartment = false;
    this.defaultWorkingDepartment = null;
  };

  resetStorePopupDepartment = () => {
    this.searchDepartment = new SearchObject();
    this.pageDepartment = null;
    this.selectedDepartment = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteDepartment = false;
  };
}
